<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Queued Live Contracts</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-searchbar placeholder="Search Documents" debounce="300" [(ngModel)]="queryText"></ion-searchbar>
    <ion-refresher slot="fixed" (ionRefresh)="refreshDocs($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Fetching Documents...">
        </ion-refresher-content>
    </ion-refresher>
    <ion-list>
        <ion-item *ngFor="let doc of queuedDocs | filterDocs: queryText" (click)="openModalDocument(doc)" class="ion-activatable">
            <ion-icon [name]="setIconDoc(doc.documentType)" color="primary"></ion-icon>
            <ion-label class="ion-padding-start">
                <p>{{doc.originalDocumentType === 1 ? 'Delivery - ' : doc.originalDocumentType === 7 ? 'Collection - ' : doc.originalDocumentType === 2 ? 'Return - ' : doc.documentType === 5 ? 'Order - ' : 'Sign Document - ' }} {{ doc.customer.name }}</p>
                <p>{{ doc.originalDocumentType === 7 ? doc.parentDocument ? doc.parentDocument.documentNumber : doc.documentNumber : doc.documentNumber}}</p>
                <p>{{doc.patient ? doc.patient.firstName : ''}}{{doc.patient ? doc.patient.lastName : ''}}  {{doc.patient ? doc.patient.id : ''}}</p>
            </ion-label>
            <ion-ripple-effect></ion-ripple-effect>
        </ion-item>
    </ion-list>

</ion-content>
